import React from "react";

// MUI Components
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

//Custom Components
import AppPage from "@/ui/AppPage/AppPage";
import RoutingSupportMap from "./RoutingSupportMap";
import { Permissions } from "@/lib/permissions";

function RoutingSupportPage() {

  return (
    <AppPage needPermission={[Permissions.Administration]}>
      <Card sx={{ m: 2, height: "90vh" }}>
        <Typography gutterBottom variant="h5" component="div" textAlign="center" sx={{ width: "100%" }}>
          Segmenti i korekcijski faktori
        </Typography>
        <RoutingSupportMap />
      </Card>

    </AppPage>
  );
}

export default RoutingSupportPage;
